<template>
  <div class="demand-info" v-if="demandInfo">
    <div>
      <div>
        <span style="font-size: 16px; font-weight: bolder; line-height: 35px">
          编号:{{ demandInfo.guid }}
        </span>
      </div>
      <div>
        <span> 当前状态: </span>
        <span
          class="demand-status"
          :style="{
            backgroundColor: getStatusColor(),
            color: '#ffffff',
          }"
          v-if="getStatusLabel()"
        >
          {{ getStatusLabel() }}
        </span>
      </div>
      <div v-if="demandInfo.storeInfo">
        要货门店: {{ demandInfo.storeInfo.name }}
      </div>
      <div v-if="demandInfo.createTime > 0">
        <span>
          创建时间:
          {{ new Date(demandInfo.createTime).format("YYYY-MM-dd hh:mm:ss") }}
        </span>
      </div>
      <div>
        <span>需求数量: </span>
        <span>共</span>
        <span style="color: #333333">
          {{ demandInfo.plannedRow }}
        </span>
        <span>种（</span>
        <span style="color: #333333">
          {{ demandInfo.plannedGoodsCount || "-" }}
        </span>
        <span>份商品 ）</span>
      </div>
      <div v-if="demandInfo.purchaseGoodsCount > 0">
        下单数量:
        <span style="color: #333333">
          {{ demandInfo.purchaseGoodsCount || "-" }}
        </span>
        <span> 份商品 </span>
      </div>
      <div v-else>
        <span>下单数量: 未下单</span>
      </div>
      <div v-if="showCost && demandInfo.freightCost > 0">
        运费成本:
        <span style="color: #333333">
          {{ demandInfo.freightCost }}
        </span>
        <span>元</span>
      </div>
      <div v-if="demandInfo.freightAmount > 0">
        运费金额:
        <span style="color: #333333">
          {{ demandInfo.freightAmount }}
        </span>
        <span>元</span>
      </div>
      <div v-if="demandInfo.discountAmount > 0">
        优惠金额:
        <span style="color: #333333">
          {{ demandInfo.discountAmount }}
        </span>
        <span>元</span>
      </div>
      <div v-if="showCost && demandInfo.totalCost > 0">
        合计成本:
        <span style="color: #333333">
          {{ demandInfo.totalCost }}
        </span>
        <span>元</span>
      </div>
      <div v-if="demandInfo.totalAmount > 0">
        合计金额:
        <span style="color: #f56c6c; font-weight: bolder">
          {{ demandInfo.totalAmount }}
        </span>
        <span>元</span>
      </div>
      <div v-else>
        <span>合计金额: 未下单</span>
      </div>
      <div v-if="demandInfo.handledBy">
        经手人员:
        <span>{{ demandInfo.handledBy }}</span>
      </div>
    </div>
    <div label="备注信息" v-if="demandInfo.optRemark">
      <div class="wordwrap">
        备注信息:
        <span class="demand-remark">{{ demandInfo.optRemark }}</span>
      </div>
    </div>
    <div
      class="demand-item-list"
      v-if="
        showCount &&
        (demandInfo.purchaseInfoCount > 0 || demandInfo.replenishInfoCount > 0)
      "
    >
      <span
        @click="purchaseListClick"
        style="
          font-size: 14px;
          cursor: pointer;
          color: #909399;
          margin-right: 10px;
        "
        v-if="demandInfo.purchaseInfoCount > 0"
      >
        共{{ demandInfo.purchaseInfoCount }}条采购记录
      </span>
      <span
        @click="replenishListClick"
        style="
          font-size: 14px;
          cursor: pointer;
          color: #909399;
          margin-right: 10px;
        "
        v-if="demandInfo.replenishInfoCount > 0"
      >
        共{{ demandInfo.replenishInfoCount }}条供货记录
      </span>
    </div>
  </div>
</template>

<style lang="less" scoped>
.demand-remark {
  font-weight: bolder;
  line-height: 30px;
  color: #000000;
}

.demand-item-list {
  background: #fafafa;
  margin-top: 10px;
  padding: 10px;

  .item-info {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-top: 20px;
    margin-bottom: 20px;
    font-size: 14px;
  }

  .item-count {
    font-size: 14px;
  }
}

.demand-status {
  width: auto;
  padding: 2px 5px;
  background-color: #ffffff;
  font-weight: 400;
  margin-right: 5px;
  border-radius: 5px;
  font-size: 14px;
  color: #5c5c5c;
}
</style>

<script>
export default {
  props: {
    showCount: {
      type: Boolean,
      default: false
    },
    showCost: {
      type: Boolean,
      default: false
    },
    demandInfo: {
      type: Object
    }
  },
  methods: {
    purchaseListClick() {
      this.$emit('purchaseListClick', this.demandInfo)
    },
    replenishListClick() {
      this.$emit('replenishListClick', this.demandInfo)
    },
    getStatusColor() {
      if (this.demandInfo.optStatus == 0) {
        return "#5c5c5c";
      } else if (this.demandInfo.optStatus == 1) {
        return "#E6A23C";
      } else if (this.demandInfo.optStatus == 2) {
        return "#6F88A1";
      } else if (this.demandInfo.optStatus == 3) {
        return "#409EFF";
      } else if (this.demandInfo.optStatus == 4) {
        return "#67C23A";
      } else if (this.demandInfo.optStatus == 5) {
        return "#F56C6C";
      }
      return "#919191";
    },
    getStatusLabel() {
      if (this.demandInfo.optStatus == 0) {
        return "等待处理";
      } else if (this.demandInfo.optStatus == 1) {
        return "等待下单";
      } else if (this.demandInfo.optStatus == 2) {
        return "部分下单";
      } else if (this.demandInfo.optStatus == 3) {
        return "全部下单";
      } else if (this.demandInfo.optStatus == 4) {
        return "已完成的";
      } else if (this.demandInfo.optStatus == 5) {
        return "已关闭的";
      }
      return '';
    },
  },
}
</script>
